const enumPayment = {
  REJEITADO: 'Não aprovado',
  PAGO: 'Aprovado',
  CANCELADO: 'Não aprovado',
  PROCESSANDO: 'Processando',
  'EM PROCESSAMENTO': 'Em processamento',
};

export default enumPayment;
